import {ThunkAction} from 'redux-thunk';
import {Action} from 'redux';
import {IStore} from '../interface';
import {getAssistantDialogue} from '../pageAsyncActions';
import {clearErrorAction, finishLoadingAction, setErrorAction, startLoadingAction} from '../status/actions';
import {getPatientAssistantDialogueApi} from '../api/patientHome';
import {IPatientAssistantDialogue} from '../intervention/interfaces';
import {
  assistantDialogueAssignedAction,
  assistantDialogueRequestedAction,
  assistantDialogueUnassignedAction,
  assistantDialogueUnavailableAction
} from './actions';

const isUnassigned = (data: unknown): boolean => {
  return (data as {assigned?: unknown} | null)?.assigned === false;
};

// The assigned body carries no `assigned` flag; it is recognised by a usable dialogueId.
const isAssigned = (data: unknown): data is IPatientAssistantDialogue => {
  return typeof data === 'object' && data !== null
    && !isUnassigned(data)
    && Number.isInteger((data as Partial<IPatientAssistantDialogue>).dialogueId);
};

export const loadAssistantDialogueAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {auth: {auth0Client} } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getAssistantDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    dispatch(assistantDialogueRequestedAction());
    try {
      const {data} = await getPatientAssistantDialogueApi();

      dispatch(finishLoadingAction(actionKey));
      // The tab was left (state cleared) while the request was in flight: drop the result so a
      // later visit never renders it before its own request resolves.
      if (getState().assistant.status !== 'loading') {
        return;
      }
      if (isUnassigned(data)) {
        dispatch(assistantDialogueUnassignedAction());
      } else if (isAssigned(data)) {
        dispatch(assistantDialogueAssignedAction(data));
      } else {
        console.error('loadAssistantDialogueAction: unexpected response', data);
        dispatch(assistantDialogueUnavailableAction());
      }
    } catch (e) {
      console.log('loadAssistantDialogueAction', e);
      // No toast via errorHandler: the tab renders its own retry state, and a toast on top of it
      // would repeat the same message.
      dispatch(setErrorAction({key: actionKey, value: e}));
      dispatch(finishLoadingAction(actionKey));
      if (getState().assistant.status === 'loading') {
        dispatch(assistantDialogueUnavailableAction());
      }
    }
  }
});
